import React, { useRef, useEffect, useState } from "react";
import ProfileComponent from "../../../components/profile/ProfileComponent";
import prisma from "../../../lib/prisma";


const userProfile = ({ fUser }) => {
 return (
    <ProfileComponent fUser={fUser} />
 )
};

export default userProfile;

export async function getStaticPaths() {
  const receivedUsers = await prisma.user.findMany({
    where: {
      slug: {
        not: null,
      },
      industryRole: {
        not: "Principal",
      },
      brokerage: "Avison Young - Ottawa",
    },
    select: {
      slug: true,
    },
  });

  const starterPaths = [];

  receivedUsers.forEach((doc) => {
    starterPaths.push({
      params: doc,
    });
  });

  return {
    paths: starterPaths,
    fallback: "blocking",
  };
}

export async function getStaticProps({ params }) {
  const fUser = await prisma.user.findFirst({
    where: {
      slug: {
        equals: params.slug,
        mode: "insensitive",
      },
    },
    select: {
      firstName: true,
      lastName: true,
      fullName: true,
      pro: true,
      brokerage: true,
      phone: true,
      uid: true,
      specialization: true,
      photoURL: true,
      welcomeAssist: true,
      brokeragePhoto: true,
      link: true,
      location: true,
      industryRole: true,
      about: true,
      title: true,
      facebook: true,
      instagram: true,
      linkedin: true,
      twitter: true,
      Listings: {
        where: {
          status: {
            in: ["Available", "Conditionally Sold"],
          },
        },
        select: {
          price: true,
          unpriced: true,
          offMarket: true,
          imageOrder: true,
          imageURLs: true,
          imagesFresh: true,
          priceType: true,
          type: true,
          city: true,
          province: true,
          subject: true,
          id: true,
          primaryImg: true,
          propertyTypes: true,
          businessType: true,
          businessCategory: true,
          subTypes: true,
          totalBuildingSize: true,
          lotSize: true,
          lotSizeUnit: true,
          grossRevenue: true,
        },

        orderBy: {
          timeStamp: "desc",
        },
      },
      coListings: {
        where: {
          status: {
            in: ["Available", "Conditionally Sold"],
          },
        },
        select: {
          price: true,
          unpriced: true,
          offMarket: true,
          imageOrder: true,
          imageURLs: true,
          imagesFresh: true,
          priceType: true,
          type: true,
          city: true,
          province: true,
          subject: true,
          id: true,
          primaryImg: true,
          propertyTypes: true,
          businessType: true,
          businessCategory: true,
          subTypes: true,
          totalBuildingSize: true,
          lotSize: true,
          lotSizeUnit: true,
          grossRevenue: true,
        },

        orderBy: {
          timeStamp: "desc",
        },
      },
    },
  });

  if (!fUser) {
    return {
      notFound: true,
    };
  }
  const userDetails = JSON.parse(JSON.stringify(fUser));

  return {
    props: {
      fUser: userDetails,
      // uid
    },

    revalidate: 3600, // In seconds
  };
}

